export default {"src":"/_next/static/media/full-width.64455f48.svg","height":284,"width":1197,"blurWidth":0,"blurHeight":0};